import React from "react";
import Modal from "../../Components/Modal";
import Typography from "@mui/material/Typography";
import {Button, Grid} from "@mui/material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {estruturaMercadologica} from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import {useSnackbar} from "notistack";

interface IRemoveEanProps {
    idEan: number;
    reloadResourceTable: () => void;
    close: () => void;
}

const RemoveEan: React.FC<IRemoveEanProps> = ({
                                                          idEan,
                                                          reloadResourceTable,
                                                          close
                                                      }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { setLoading, loading } = useGlobalContext();

    const handleCloseModal = () => {
        close();
    };

    const handleRemoveSped = async () => {

        if (idEan === 0) {
            return;
        }

        setLoading && setLoading(true);
        const {
            data = '',
            status = 500,
            message = ''
        } = await estruturaMercadologica.delete(idEan + '');
        setLoading && setLoading(false);

        if (data || message) {
            const variant = (status === 200 || status === 204)? 'success' :'error' ;
            enqueueSnackbar(message, {variant: variant});
        }

        close();

        reloadResourceTable();
    }

    return (<>
        <Modal
            title='Remover importação de Tabela EAN'
            open={!loading}
            closeModal={handleCloseModal}
            maxWidth='sm'
        >
            <Grid container>
                <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="body1">
                        Tem certeza de que deseja remover esta importação de TABELA EAN?<br/><br/> <Typography component="span" sx={{fontWeight: 'bold'}}>Esta ação é irreversível!</Typography>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={12} mt={3} marginBottom={2} display='flex' justifyContent='flex-end'>
                    <Button variant="contained" color="error"
                            onClick={handleRemoveSped}>
                        <DeleteForeverIcon
                            sx={{
                                marginRight: '5px',
                                marginBottom: '3px',
                                // color: '#777777',
                                alignItems: 'baseline'
                            }}
                        /> Sim, prosseguir com a remoção
                    </Button>
                </Grid>
            </Grid>

        </Modal>
    </>);
}

export default RemoveEan;